import { ChangeEvent } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { NeuTextarea, NeuTextareaProps } from '@hcahealthcaredpx/neutron-react';

import { REQUIRED_SYMBOL } from './constants';

type FormTextareaProps = Omit<NeuTextareaProps, 'name'> & {
  name: string;
};

export const FormTextarea = ({
  name,
  label = '',
  required,
  ...rest
}: FormTextareaProps): JSX.Element => {
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext();

  const errorMessage = errors?.[name]?.message as string | undefined;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <NeuTextarea
          label={required && label ? `${label} ${REQUIRED_SYMBOL}` : label}
          required={required}
          value={field.value}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
            field.onChange(e.target.value);
          }}
          onNeuBlur={() => trigger(name)}
          invalid={errorMessage}
          error={!!errorMessage}
          {...rest}
        />
      )}
    />
  );
};
